import { UtilityFunctions } from '../shared/utility-functions';
import { CONSTANT_VALUES } from '../constants/constant-values';
export class BaseMember {
    protected popUpMessage = '';
    protected popupTitle = 'Error';
    protected vendor;
    protected memberList = [];
    protected noMemberAvailable: boolean = true;
    protected searchMember = '';
    protected openSubMenu1 = false;
    protected openSubMenu2 = false;
    protected openSubMenu3 = false;
    protected facilityFilter = [];
    protected facilityList = [];
    protected groupFilter = [];
    protected groupList = [];
    protected preferenceList = [];
    protected preferenceFilter = [];
    protected utilityFunctions = new UtilityFunctions();
    protected filterState = '';
    protected filterStateSubMenuList = [];
    protected allFilter = true;
    protected showFilterFacility = false;
    constructor() { }

    /**
     * Get facility list
     * 
     * @param {any} that 
     * 
     * @memberof BaseMember
     */
    getFacilityListForMemberFilter(that) {
        that.appService.getFacilityList(that.vendor._id).then((result: any) => {
            if (result.status === 'SUCCESS') {
                that.facilityList = result.facilityData;
                that.preferenceList = JSON.parse(JSON.stringify(that.facilityList));
            }
        });
    }

    /**
     * Get group list for condo
     * 
     * @param {any} that 
     * 
     * @memberof BaseMember
     */
    getGroupListForFilter(that) {
        let vendorObj = { vendorId: that.vendor._id };
        that.appService.getListOfGroup(vendorObj).then((data: any) => {
            if (data.status === 'SUCCESS') {
                that.groupList = data.groups;
            }
        });
    }
    /**
     * Set vendor id as per role
     * 
     * @param {any} that 
     * @param {any} pageNo 
     * @returns 
     * 
     * @memberof BaseMember
     */
    setVendorIdAsPerRole(that, pageNo) {
        let vendorObject = {
            'vendorId': '',
            perPage: that.pageOptions.noOfPageItem,
            pageNumber: pageNo ? pageNo : that.pageOptions.currentPage,
            filters: []
        };
        if (that.vendor.role === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
            vendorObject['vendorId'] = this.vendor._id;
        } else if (that.vendor.role === CONSTANT_VALUES.SUPER_ADMIN) {
            let subVendor = that.vendor.subVendors[0];
            vendorObject['vendorId'] = subVendor._id;
        }
        return vendorObject;
    }
}


// WEBPACK FOOTER //
// ./src/app/member/base-member.ts